import React from "react";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { FaUser } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

export const SchedulePostFooter = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    console.log('Clicked')
    navigate('/appointment');
  };

  return (
    <button
      onClick={handleClick}
      type="submit"
      className="md:hidden mx-auto mt-8 font-bold bg-primary hover:bg-opacity-80 flex items-center gap-2 text-lg text-white p-2 px-4 rounded-3xl hover:bg-primary-dark transition duration-200"
    >
      <div>
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6269_1560)">
            <path
              d="M12 0.26123C15.2604 0.26123 15.6672 0.27323 16.9464 0.33323C18.2244 0.39323 19.0944 0.593631 19.86 0.891231C20.652 1.19603 21.3192 1.60883 21.9864 2.27483C22.5966 2.87471 23.0687 3.60034 23.37 4.40123C23.6664 5.16563 23.868 6.03683 23.928 7.31483C23.9844 8.59403 24 9.00083 24 12.2612C24 15.5216 23.988 15.9284 23.928 17.2076C23.868 18.4856 23.6664 19.3556 23.37 20.1212C23.0696 20.9226 22.5973 21.6484 21.9864 22.2476C21.3864 22.8576 20.6608 23.3297 19.86 23.6312C19.0956 23.9276 18.2244 24.1292 16.9464 24.1892C15.6672 24.2456 15.2604 24.2612 12 24.2612C8.7396 24.2612 8.3328 24.2492 7.0536 24.1892C5.7756 24.1292 4.9056 23.9276 4.14 23.6312C3.33879 23.3306 2.61303 22.8584 2.0136 22.2476C1.40329 21.6479 0.931118 20.9222 0.63 20.1212C0.3324 19.3568 0.132 18.4856 0.0719999 17.2076C0.0155999 15.9284 0 15.5216 0 12.2612C0 9.00083 0.0119999 8.59403 0.0719999 7.31483C0.132 6.03563 0.3324 5.16683 0.63 4.40123C0.930283 3.59985 1.40256 2.87402 2.0136 2.27483C2.61321 1.66431 3.33891 1.19211 4.14 0.891231C4.9056 0.593631 5.7744 0.39323 7.0536 0.33323C8.3328 0.27683 8.7396 0.26123 12 0.26123ZM12 6.26123C10.4087 6.26123 8.88258 6.89337 7.75736 8.01859C6.63214 9.14381 6 10.6699 6 12.2612C6 13.8525 6.63214 15.3787 7.75736 16.5039C8.88258 17.6291 10.4087 18.2612 12 18.2612C13.5913 18.2612 15.1174 17.6291 16.2426 16.5039C17.3679 15.3787 18 13.8525 18 12.2612C18 10.6699 17.3679 9.14381 16.2426 8.01859C15.1174 6.89337 13.5913 6.26123 12 6.26123ZM19.8 5.96123C19.8 5.56341 19.642 5.18188 19.3607 4.90057C19.0794 4.61927 18.6978 4.46123 18.3 4.46123C17.9022 4.46123 17.5206 4.61927 17.2393 4.90057C16.958 5.18188 16.8 5.56341 16.8 5.96123C16.8 6.35906 16.958 6.74059 17.2393 7.02189C17.5206 7.3032 17.9022 7.46123 18.3 7.46123C18.6978 7.46123 19.0794 7.3032 19.3607 7.02189C19.642 6.74059 19.8 6.35906 19.8 5.96123ZM12 8.66123C12.9548 8.66123 13.8705 9.04051 14.5456 9.71565C15.2207 10.3908 15.6 11.3065 15.6 12.2612C15.6 13.216 15.2207 14.1317 14.5456 14.8068C13.8705 15.4819 12.9548 15.8612 12 15.8612C11.0452 15.8612 10.1295 15.4819 9.45442 14.8068C8.77928 14.1317 8.4 13.216 8.4 12.2612C8.4 11.3065 8.77928 10.3908 9.45442 9.71565C10.1295 9.04051 11.0452 8.66123 12 8.66123Z"
              fill="#ffffff"
            />
          </g>
          <defs>
            <clipPath id="clip0_6269_1560">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.26123)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      Schedule Photoshoot
    </button>
  );
};

export const SchedulePost = ({ isHeader }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    console.log('Clicked')
    navigate('/appointment');
  };

  return (
    <button
      onClick={handleClick}
      type="submit"
      className={`border mx-auto font-bold flex items-center justify-center gap-2 sm:min-w-44 p-2 px-4 rounded-3xl transition duration-200 
      ${isHeader ? 'bg-white text-primary border-primary' : 'bg-primary text-white border-white hover:bg-opacity-80'}`}
    >
      <div>
        <svg
          width="14"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6269_1560)">
            <path
              d="M12 0.26123C15.2604 0.26123 15.6672 0.27323 16.9464 0.33323C18.2244 0.39323 19.0944 0.593631 19.86 0.891231C20.652 1.19603 21.3192 1.60883 21.9864 2.27483C22.5966 2.87471 23.0687 3.60034 23.37 4.40123C23.6664 5.16563 23.868 6.03683 23.928 7.31483C23.9844 8.59403 24 9.00083 24 12.2612C24 15.5216 23.988 15.9284 23.928 17.2076C23.868 18.4856 23.6664 19.3556 23.37 20.1212C23.0696 20.9226 22.5973 21.6484 21.9864 22.2476C21.3864 22.8576 20.6608 23.3297 19.86 23.6312C19.0956 23.9276 18.2244 24.1292 16.9464 24.1892C15.6672 24.2456 15.2604 24.2612 12 24.2612C8.7396 24.2612 8.3328 24.2492 7.0536 24.1892C5.7756 24.1292 4.9056 23.9276 4.14 23.6312C3.33879 23.3306 2.61303 22.8584 2.0136 22.2476C1.40329 21.6479 0.931118 20.9222 0.63 20.1212C0.3324 19.3568 0.132 18.4856 0.0719999 17.2076C0.0155999 15.9284 0 15.5216 0 12.2612C0 9.00083 0.0119999 8.59403 0.0719999 7.31483C0.132 6.03563 0.3324 5.16683 0.63 4.40123C0.930283 3.59985 1.40256 2.87402 2.0136 2.27483C2.61321 1.66431 3.33891 1.19211 4.14 0.891231C4.9056 0.593631 5.7744 0.39323 7.0536 0.33323C8.3328 0.27683 8.7396 0.26123 12 0.26123ZM12 6.26123C10.4087 6.26123 8.88258 6.89337 7.75736 8.01859C6.63214 9.14381 6 10.6699 6 12.2612C6 13.8525 6.63214 15.3787 7.75736 16.5039C8.88258 17.6291 10.4087 18.2612 12 18.2612C13.5913 18.2612 15.1174 17.6291 16.2426 16.5039C17.3679 15.3787 18 13.8525 18 12.2612C18 10.6699 17.3679 9.14381 16.2426 8.01859C15.1174 6.89337 13.5913 6.26123 12 6.26123ZM19.8 5.96123C19.8 5.56341 19.642 5.18188 19.3607 4.90057C19.0794 4.61927 18.6978 4.46123 18.3 4.46123C17.9022 4.46123 17.5206 4.61927 17.2393 4.90057C16.958 5.18188 16.8 5.56341 16.8 5.96123C16.8 6.35906 16.958 6.74059 17.2393 7.02189C17.5206 7.3032 17.9022 7.46123 18.3 7.46123C18.6978 7.46123 19.0794 7.3032 19.3607 7.02189C19.642 6.74059 19.8 6.35906 19.8 5.96123ZM12 8.66123C12.9548 8.66123 13.8705 9.04051 14.5456 9.71565C15.2207 10.3908 15.6 11.3065 15.6 12.2612C15.6 13.216 15.2207 14.1317 14.5456 14.8068C13.8705 15.4819 12.9548 15.8612 12 15.8612C11.0452 15.8612 10.1295 15.4819 9.45442 14.8068C8.77928 14.1317 8.4 13.216 8.4 12.2612C8.4 11.3065 8.77928 10.3908 9.45442 9.71565C10.1295 9.04051 11.0452 8.66123 12 8.66123Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_6269_1560">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.26123)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      Schedule Photoshoot
    </button>
  );
};

export const BookFreeSession = () => {
  return (
    <button
      type="submit"
      className="mx-auto mt-8 font-bold bg-primary hover:bg-opacity-80 flex items-center justify-center gap-2 min-w-full sm:min-w-44 text-white p-2 px-4 rounded-3xl transition duration-200"
    >
      <MdOutlineKeyboardArrowDown className="w-8 h-8" />
      Book free session
    </button>
  );
};

export const BookPhotoSession = () => {
  return (
    <button
      type="submit"
      className="font-bold border border-textNeutral flex hover:bg-textNeutral hover:text-white items-center justify-center gap-2 w-full sm:w-auto text-textNeutral py-3 px-4 rounded-3xl transition ease-in duration-300 grp__btn"
    >
      <div>
        <svg
          width="14"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_6269_1560)">
            <path
              className="hover-fill"
              d="M12 0.26123C15.2604 0.26123 15.6672 0.27323 16.9464 0.33323C18.2244 0.39323 19.0944 0.593631 19.86 0.891231C20.652 1.19603 21.3192 1.60883 21.9864 2.27483C22.5966 2.87471 23.0687 3.60034 23.37 4.40123C23.6664 5.16563 23.868 6.03683 23.928 7.31483C23.9844 8.59403 24 9.00083 24 12.2612C24 15.5216 23.988 15.9284 23.928 17.2076C23.868 18.4856 23.6664 19.3556 23.37 20.1212C23.0696 20.9226 22.5973 21.6484 21.9864 22.2476C21.3864 22.8576 20.6608 23.3297 19.86 23.6312C19.0956 23.9276 18.2244 24.1292 16.9464 24.1892C15.6672 24.2456 15.2604 24.2612 12 24.2612C8.7396 24.2612 8.3328 24.2492 7.0536 24.1892C5.7756 24.1292 4.9056 23.9276 4.14 23.6312C3.33879 23.3306 2.61303 22.8584 2.0136 22.2476C1.40329 21.6479 0.931118 20.9222 0.63 20.1212C0.3324 19.3568 0.132 18.4856 0.0719999 17.2076C0.0155999 15.9284 0 15.5216 0 12.2612C0 9.00083 0.0119999 8.59403 0.0719999 7.31483C0.132 6.03563 0.3324 5.16683 0.63 4.40123C0.930283 3.59985 1.40256 2.87402 2.0136 2.27483C2.61321 1.66431 3.33891 1.19211 4.14 0.891231C4.9056 0.593631 5.7744 0.39323 7.0536 0.33323C8.3328 0.27683 8.7396 0.26123 12 0.26123ZM12 6.26123C10.4087 6.26123 8.88258 6.89337 7.75736 8.01859C6.63214 9.14381 6 10.6699 6 12.2612C6 13.8525 6.63214 15.3787 7.75736 16.5039C8.88258 17.6291 10.4087 18.2612 12 18.2612C13.5913 18.2612 15.1174 17.6291 16.2426 16.5039C17.3679 15.3787 18 13.8525 18 12.2612C18 10.6699 17.3679 9.14381 16.2426 8.01859C15.1174 6.89337 13.5913 6.26123 12 6.26123ZM19.8 5.96123C19.8 5.56341 19.642 5.18188 19.3607 4.90057C19.0794 4.61927 18.6978 4.46123 18.3 4.46123C17.9022 4.46123 17.5206 4.61927 17.2393 4.90057C16.958 5.18188 16.8 5.56341 16.8 5.96123C16.8 6.35906 16.958 6.74059 17.2393 7.02189C17.5206 7.3032 17.9022 7.46123 18.3 7.46123C18.6978 7.46123 19.0794 7.3032 19.3607 7.02189C19.642 6.74059 19.8 6.35906 19.8 5.96123ZM12 8.66123C12.9548 8.66123 13.8705 9.04051 14.5456 9.71565C15.2207 10.3908 15.6 11.3065 15.6 12.2612C15.6 13.216 15.2207 14.1317 14.5456 14.8068C13.8705 15.4819 12.9548 15.8612 12 15.8612C11.0452 15.8612 10.1295 15.4819 9.45442 14.8068C8.77928 14.1317 8.4 13.216 8.4 12.2612C8.4 11.3065 8.77928 10.3908 9.45442 9.71565C10.1295 9.04051 11.0452 8.66123 12 8.66123Z"
              fill="#909090"
            />
          </g>
          <defs>
            <clipPath id="clip0_6269_1560">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0 0.26123)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      Book photo session
    </button>
  );
};


export const BecomeaMember = () => {
  return (
    <button
      type="submit"
      className="mx-auto font-bold border border-textNeutral hover:bg-textNeutral hover:text-white flex items-center justify-center gap-2 min-w-full sm:min-w-44 text-textNeutral py-3  px-4 rounded-3xl transition ease-in duration-300"
    >
      <FaUser className="w4 h-4" />
      Become a member
    </button>
  );
};
